import './../../../fonts';
import { getDefaultTheme } from './getThemeConfig';

export default {
  ...getDefaultTheme(),
  overrides: {
    MuiButton: {
      contained: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none'
        },
        '&:hover': {
          boxShadow: 'none'
        }
      },
      outlined: {
        height: 40,
        padding: 6
      },
      outlinedPrimary: {
        border: '1px solid #E8E8E8'
      },
      root: {
        borderRadius: 20,
        height: 40,
        padding: 6,
        textTransform: 'none'
      }
    }
  },
  palette: {
    background: {
      default: '#f5f5f5'
    },
    primary: {
      light: '#3f9beb',
      main: '#2D91E9',
      dark: '#3f9beb'
    },
    textColors: {
      body: '#4A4A4A'
    }
  },
  portal: {
    assets: '/assets/whitelabel',
    header: {
      background: '#FFF'
    },
    logo: '',
    logoBGSize: 'auto 30px'
  },
  typography: {
    color: '#4A4A4A',
    fontFamily: 'CircularStd',
    h4: {
      fontSize: '2rem',
      fontWeight: '600',
      '@media(max-width: 440px)': {
        fontSize: '1.6rem',
      },
    },
    body1: {
      fontSize: '1.6rem',
      '@media (max-width: 598px)': {
        fontSize: '1.4rem',
        lineHeight: 1.45
      }
    },
    button: {
      fontSize: '1.6rem'
    }
  }
};
